import {useState, useCallback, useMemo} from 'react';

export type ValidationErrors = Record<string, string | null>;

export const useTableCellValidation = () => {
    const [cellErrors, setCellErrors] = useState<ValidationErrors>({});

    const setCellError = useCallback((key: string, error: string | null) => {
        setCellErrors((prev) => ({...prev, [key]: error}));
    }, []);

    const hasTableErrors = useMemo(() => {
        return Object.values(cellErrors).some((error) => error !== null);
    }, [cellErrors]);

    return {
        cellErrors,
        setCellError,
        hasTableErrors,
    };
};
